export enum ChooseUploadType {
  bulkUpload = "bulkUpload",
  account = "account",
}

export interface User {
  user?: UserData;
  order: UserOrder;
}

export interface Manufacturer {
  id: string;
  email: string;
  name: string;
}

export interface UserData {
  id: string;
  email: string;
  name?: string;
  manufacturerName?: string;
  isAdmin: boolean;
  isManufacturer: boolean;
}

export interface RemoteConfig {
  remoteHost: string;
  remotePort: number;
  remoteUsername: string;
  remotePassword: string;
}

export interface IAddress {
  companyName: string;
  addressLine1: string;
  addressLine2: string;
  street?: string;
  zipCode: string;
  city: string;
  country: string;
  phone: string;
}

export interface UserOrder {
  id: string;
  customerNumber: string;
  notificationAt?: string;
  email: string;
  status: StatusConst;
  billingAdress: IAddress;
  chooseUpload?: ChooseUploadType;
  shippingAdress: IAddress;
  files: ImageFile[];
  furtherInfoFlowingMotifs?: boolean;
  furtherInfoQualityCheck?: boolean;
  furtherInfo?: string;
  printManufacturer?: string;
  positions: Position[];
  deliveryDate?: string | Date | null;
  lastOpened?: string;
  lastUpdatedBy?: string;
  manufacturerNote?: string;
  internalNote?: string;
  shippingMethod?: ShippingMethod;
}

export interface Position {
  articleNumber: string;
  articleName: string;
  quantity: number; // float
  productGroup: "GO" | "EXPO" | "WHITE";
  widthByMm: number;
  heightByMm: number;
  White: boolean;
  positionImage?: PositionImage[];
}

export interface PositionImage {
  key: string;
  pdfKey?: string;
  quantity: number;
  thumbnail: string;
  //dpi: number;
  comment?: string;
  //aspectRatio: AspectRatio;
  approvalStatus?: ApprovalStatus;
  filledPositionArticleNumber?: string[];
  acceptedDescription?: string;
  rejectedReason?: string;
  rejectedDescription?: string;
  fullName?: string;
  files?: ImageFile[];
  size?: number;
}

export interface ImageFile {
  key: string;
  name: string;
}

export interface PdfData {
  _ratio?: {
    x: number;
    y: number;
    fit: boolean;
  };
  _dpi?: number;
  _key?: string;
  _numPages?: number;
  _isLarge?: boolean;
}

export interface AspectRatio {
  x: number;
  y: number;
  fit: boolean;
}

export enum ApprovalStatus {
  Yes = "Yes",
  No = "No",
}

export enum ShippingMethod {
  Express = "Express",
  Standard = "Standard",
}

export enum StatusConst {
  Waiting = "Waiting",
  Error = "Error",
  Uploaded = "Uploaded",
  ReUploaded = "ReUploaded",
  Production = "Production",
  ProductionFinished = "ProductionFinished",
}

export enum UploadStatus {
  NOT_STARTED = "NOT_STARTED",
  UPLOADING = "UPLOADING",
  PREUPLOADED = "PREUPLOADED",
  DONE = "DONE",
}

export enum SortBy {
  ASC = "ASC",
  DESC = "DESC",
}

export type ModelOrdersFilterInput = {
  printManufacturer?: ModelIDInput;
  status?: ModelIDInput;
  or?: ModelIDInput;
};

type ModelIDInput = {
  ne?: string;
  eq?: string;
  or?: object;
};

export interface IOrderActivityLog {
  id: number;
  operation: Operation;
  createdAt: string;
  field?: string;
  positionImage?: PositionImage;
  value?: string;
  updatedBy: string;
  orderItemActivityLogsId?: string;
}

export enum Operation {
  Created = "CREATE",
  Updated = "UPDATE",
  Deleted = "DELETE",
  Change = "CHANGE",
}

export enum DeclineOptions {
  ResolutionLow = "ResolutionLow",
  WrongColor = "WrongColor",
  Other = "Other",
}
